import axios from 'axios';
import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function verifyOTP(otp, customerId) {

    return axios.post(routes.verifyOTP, {
       otp, customerId
    }, {
        ...AXIOS_DEFAULT_CONFIG,

    });;
}